<template>
  <section class="section section_bg custom_page_v2" >
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <card class="loading_div section_black" v-if="is_load==false">
      <h2>Идет загрузка...</h2>
    </card>


    <div class="container" v-if="is_load">
      <div class="section_header mobile_div d-flex justify-content-center" v-if="is_load">
        <nav aria-label="breadcrumb" v-if="is_load" >
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link  tag="a"  :to="{name:'setup_verifications'}" >Верификация</router-link></li>

            <li class="breadcrumb-item active" aria-current="page">{{ form.title }}</li>
          </ol>
        </nav>
      </div>
   <div class="section_header nocenter m-4">
     <h2 class="text-center">{{ form.title }}</h2>
     <editorjsrender :blocks_json="form.content.blocks"/>
     <form-verification ref="formService" :form="form"/>
     <div class="alert alert-danger" v-if="iserror==true">
       <p>{{ error_message }}</p>
     </div>
     <base-button  @click="onSaveForm"    >Отправить заявку</base-button>
   </div>

    </div>
  </section>
</template>

<script>
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Api from "@/models/Api";
import FormVerification from "@/components/Custom/FormVerification";
import Editorjsrender from "@/models/Editorjsrender";

export default {
  name: "VerificationForm",
  components:{LoadingBlock,FormVerification,Editorjsrender},
  data(){
    return {

      "is_load":false,
      "iserror":false,
      "error_message":"",
      'form':null,

    }
  },
  methods:{
    onSaveForm(){
      var app=this;
      var result_data=app.$refs.formService.saveForm();
      if(Object.entries(result_data).length>0){
        var newProject={};
        app.is_load=false;



        newProject.form =result_data;

        app.iserror = false;
        Api.sendVerificationForm(app.form.id,newProject,function(data){
          app.is_load=true;
          app.$router.push({name: 'setup' });

        },function(err){
          app.is_load=true;
          app.iserror = true;
          app.error_message = err.response.data.message;
        });
        // Api.createProject(newProject, function (result) {
        //   app.is_load=true;
        //   if (result.iserror == false) {
        //     app.iserror = false;
        //
        //     //document.location = "/project/" + result.project_id;
        //     app.$router.push({name: 'project', params: {id: result.project_id, "rand": Math.random()}});
        //   } else {
        //     app.iserror = true;
        //     app.error_message = result.error_message;
        //   }
        // });
      }


    },
    loadMainData(){

      var app=this;
      var id = app.$route.params.id;
      Api.loadVerificationForm(id,function(data){
        app.form=data.form;
        app.is_load=true;
      },function(err){
        if (err.response.data.code == 404) {
          app.$router.push({name: '404'});
        }
      })
    }
  },
  mounted() {
    var app=this;
    app.loadMainData();

  }
}
</script>

<style scoped>

</style>